<template>
  <section id="Foods">
    <Navbar />
    <div class="container mt-3">
      <div class="title-section">
        <h3>Daftar <strong>Makanan</strong></h3>
      </div>

      <!-- Search Foods -->
      <div class="input-group my-3">
        <input
          v-model="search"
          @keyup="searchFoods"
          type="text"
          class="form-control"
          placeholder="Makan Apa Hari Ini?"
          aria-label="Makan Apa Hari Ini?"
          aria-describedby="basic-addon1"
        />
        <span class="input-group-text" id="basic-addon1"
          ><b-icon-search></b-icon-search
        ></span>
      </div>

      <div class="card-product-wrapper row">
        <div
          class="col-sm-6 col-md-4 my-3"
          v-for="product in products"
          :key="product.id"
        >
          <CardProduct :product="product" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { API_URL } from "../utils/constant";

import Navbar from "../components/Navbar.vue";
import CardProduct from "../components/CardProduct";

export default {
  name: "Foods",
  components: {
    Navbar,
    CardProduct,
  },
  data() {
    return {
      products: [],
      search: "",
    };
  },
  methods: {
    setProduct(data) {
      this.products = data;
    },
    searchFoods() {
      axios
        .get(API_URL + "/products?q=" + this.search)
        .then((res) => {
          this.setProduct(res.data);
        })
        .catch((err) => {
          console.log("failed get best product :", err);
        });
    },
  },
  mounted() {
    // Get Best Product
    axios
      .get(API_URL + "/products")
      .then((res) => {
        console.log(`get foods:`, res.data);
        this.setProduct(res.data);
      })
      .catch((err) => {
        console.log("failed get foods :", err);
      });
  },
};
</script>

<style></style>
